import { TKey } from '~/src/dash/publicaUI';

export const frequencyMap: Record<string, TKey> = {
  '0': 'Unknown',
  '1': 'Daily',
  '2': 'Weekly',
  '3': 'Monthly',
};

export const periodMap: Record<string, TKey> = {
  '0': 'Unknown',
  '1': 'LastDay',
  '2': 'Last3Days',
  '3': 'Last7Days',
  '4': 'Last15Days',
  '5': 'CurrentMonth',
  '6': 'LastMonth',
  '7': 'CurrentYear',
  '8': 'Last31Days',
  '9': 'Last14Days',
  '10': 'Last30Days',
};
